import React from 'react';
import { Button, Input, Modal, ModalBody, ModalHeader } from 'reactstrap';
import Devide from '../../../assets/images/divide.png';
import { useDispatch , useSelector } from 'react-redux';
import { fetch_web_site_link, fetch_web_site_map } from '../../../slices/thunks';
import { useState , useEffect} from 'react';
import Loader from '../Loader';

const Add_Website = ({status, web_links, setweb_links }) => {
  
    const [modal_animationZoom, setmodal_animationZoom] = useState(false);
    const BotDetails = useSelector((state) => state.BotDetails.Bot_Details);
    const [domain_to_crawl, setdomain_to_crawl] = useState('')
    const [domain_to_get_site_map, setdomain_to_get_site_map] = useState('')
    const [direct_link, setdirect_link] = useState('')
    const  create_new_bot_details =  useSelector((state) => state.Create_Bot)
    function tog_animationZoom() {
        setmodal_animationZoom(!modal_animationZoom);
    }

    const dispatch= useDispatch()


  


    

  return (
    <>
    <Button disabled={status} color="secondary" onClick={() => tog_animationZoom()} >Add link</Button>
      {/* ZoomIn Animation */}
      
            <Modal id="flipModal" isOpen={modal_animationZoom} toggle={() => { tog_animationZoom(); }} modalClassName="zoomIn modal-lg" centered >
                <ModalHeader className="modal-title" id="flipModalLabel" toggle={() => { tog_animationZoom(); }}>
                Add a website to knowledge
                </ModalHeader>
                <ModalBody>
                   { create_new_bot_details.loading ?<Loader/> : <><div className='add_website_link'>
                      <div className='add_website_hed'>
                          <p>Crawl</p>
                      </div>
                      <div className='add_website_body'>
                          <Input value={domain_to_crawl} onChange={(e) => {
                              setdomain_to_crawl(e.target.value);
                          } } type="text" className="form-control" id="website_link" />
                          <Button onClick={async () => {
                              if (domain_to_crawl.trim().length > 0) {

                                  dispatch(fetch_web_site_link({ domain: domain_to_crawl , Bot_Id:BotDetails.Bot_ID }));
                                  tog_animationZoom()
                                  
                              }
                          } } color="secondary"> FETCH LINK</Button>
                      </div>
                      <p><small>This will crawl all the links starting with the URL (not including files on the website).</small></p>
                  </div><div className='divide'>
                          <img src={Devide} alt='divide' />
                      </div><div className='add_website_link'>
                          <div className='add_website_hed'>
                              <p>Add a direct URL</p>
                          </div>
                          <div className='add_website_body'>
                              <Input value={direct_link} onChange={(e)=>{
                                setdirect_link(e.target.value);
                              }}  type="text" className="form-control" id="add_link" />
                              <Button onClick={()=>{
                                setweb_links([...web_links,{Url_Knowledge_Id:null,
                                Bot_Id:BotDetails.Bot_ID,
                                Url_Link:direct_link,
                                Uploaded_To_VectorDB:false,
                                Url_Char_Count:null
                                }])
                                tog_animationZoom()
                              }} color="secondary"> ADD LINK</Button>
                          </div>
                          <p><small>This will only apply on the pasted url.</small></p>
                      </div><div className='divide'>
                          <img src={Devide} alt='divide' />
                      </div><div className='add_website_link'>
                          <div className='add_website_hed'>
                              <p>Sitemap URL</p>
                          </div>
                          <div className='add_website_body'>
                              <Input value={domain_to_get_site_map} onChange={(e)=>{
                                setdomain_to_get_site_map(e.target.value);
                              }} type="text" className="form-control" id="load_sitemap" />
                              <Button onClick={()=>{
                                if(domain_to_get_site_map.length > 0){

                                    dispatch(fetch_web_site_map({ domain: domain_to_get_site_map ,  Bot_Id:BotDetails.Bot_ID  }))
                                    tog_animationZoom()
                                }
                              }} color="secondary"> LOAD SITEMAP</Button>
                          </div>
                          <p><small>This will crawl all the links in the sitemap.</small></p>
                      </div></>}
                </ModalBody>
       </Modal>
    </>
  )
}

export default Add_Website
